// @flow

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LANGUAGE_DONE = 'SET_LANGUAGE_DONE';
